// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanTriggerAction } from "./hook";

export type CanTriggerActionProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanTriggerAction({
  children,
  fallback,
  scope,
}: CanTriggerActionProps) {
  const canDoAction = useCanTriggerAction(scope);
  return <>{canDoAction ? children : fallback}</>;
}
